import { createGlobalStyle } from 'styled-components'
import config from './config'

export const GlobalFontFaces = createGlobalStyle`
    /* Lato - Primary font for content and UI */
    @font-face {
        font-family: 'Lato';
        src: local('Lato Regular'), local('Lato-Regular'),
            url('${config.assetPrefix}/fonts/Lato-Regular.woff2') format('woff2');
        font-weight: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Lato';
        src: local('Lato Bold'), local('Lato-Bold'), url('${config.assetPrefix}/fonts/Lato-Bold.woff2') format('woff2');
        font-weight: bold;
        font-display: swap;
    }

    /* Yummo - Brand font for headings and special elements */
    @font-face {
        font-family: 'Yummo';
        src: local('Yummo Bold'), local('Yummo-Bold'),
            url('${config.assetPrefix}/fonts/Yummo-Bold.otf') format('opentype');
        font-weight: bold;
        font-display: swap;
    }

    @font-face {
        font-family: 'Yummo';
        src: local('Yummo Regular'), local('Yummo-Regular'),
            url('${config.assetPrefix}/fonts/Yummo-Regular.otf') format('opentype');
        font-weight: normal;
        font-display: swap;
    }

    /* Inter - Minimal usage, single weight only */
    @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400 700;
        font-display: swap;
        src: local('Inter'), url('${config.assetPrefix}/fonts/Inter.woff2') format('woff2');
    }
`
